import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal } from "@/lib/motion";
import { IMAGES } from "@/lib/images";
import { Quote, X, ZoomIn } from "lucide-react";

const transformations = [
  IMAGES.t1,
  IMAGES.t2,
  IMAGES.t3,
  IMAGES.t4,
  IMAGES.t5,
  IMAGES.t6,
  IMAGES.t7,
  IMAGES.t8,
];

export const Gallery = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="efekty" className="relative py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <Reveal>
            <span className="text-xs uppercase tracking-[0.25em] text-[#FF6B6B]">Efekty</span>
            <h2 className="font-display font-light text-4xl md:text-6xl mt-6 leading-[0.95] max-w-2xl">
              Przemiany, które <span className="italic text-[#FF6B6B]">naprawdę</span> się wydarzyły
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-muted max-w-sm md:text-right text-sm">
              Prawdziwe podopieczne, prawdziwe efekty treningów personalnych w Zdrofit Warszawa
              Stegny. Kliknij, aby powiększyć.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {transformations.map((img, i) => (
            <Reveal key={i} delay={(i % 4) * 0.08}>
              <button
                onClick={() => setActive(img)}
                data-testid={`transformation-${i}`}
                className="group relative w-full overflow-hidden bg-[#1A1718] border border-[#2A2626] block"
              >
                <img
                  src={img}
                  alt={`Metamorfoza podopiecznej ${i + 1}`}
                  className="w-full aspect-[4/5] object-cover object-top group-hover:scale-[1.04] transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-[#0F0E0E]/0 group-hover:bg-[#0F0E0E]/30 transition-colors duration-500 flex items-center justify-center">
                  <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 w-12 h-12 rounded-full bg-[#FF6B6B] text-[#0F0E0E] flex items-center justify-center">
                    <ZoomIn className="w-5 h-5" />
                  </span>
                </div>
              </button>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-20 border border-[#2A2626] bg-[#1A1718] p-10 md:p-16 relative">
            <Quote className="w-10 h-10 text-[#FF6B6B]/40 absolute top-8 left-8" />
            <p className="font-display font-light text-2xl md:text-4xl leading-snug max-w-4xl mx-auto text-center italic">
              „Pierwszy raz od lat czuję się dobrze we własnym ciele. Nie chodziło tylko o kilogramy
              — odzyskałam pewność siebie."
            </p>
            <p className="text-center text-sm uppercase tracking-[0.2em] text-muted mt-8">
              — Sylwia, 39 lat
            </p>
          </div>
        </Reveal>
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {active && (
          <motion.div
            data-testid="lightbox-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setActive(null)}
            className="fixed inset-0 z-[100] bg-[#0F0E0E]/92 backdrop-blur-md flex items-center justify-center p-4 md:p-10"
          >
            <button
              onClick={() => setActive(null)}
              data-testid="lightbox-close"
              className="absolute top-6 right-6 w-12 h-12 rounded-full border border-[#2A2626] text-[#F5F2F0] flex items-center justify-center hover:border-[#FF6B6B] hover:text-[#FF6B6B] transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
            <motion.img
              key={active}
              initial={{ scale: 0.92, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.92, opacity: 0 }}
              transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
              src={active}
              alt="Metamorfoza — pełny rozmiar"
              onClick={(e) => e.stopPropagation()}
              className="max-h-[88vh] max-w-full object-contain shadow-2xl"
            />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};
